/* eslint-disable */
export default {
  title: 'Reply with Voice Message',
  customMessage: 'Custom message',
  customMessagePlaceholder: 'Type a custom message',
} as const;

// @key: @#@"title"@#@ @source: @#@"Reply with Voice Message"@#@
// @key: @#@"customMessage"@#@ @source: @#@"Custom message"@#@
// @key: @#@"customMessagePlaceholder"@#@ @source: @#@"Type a custom message"@#@
